async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(data.message || `Request failed (${response.status})`);
    err.reasons = data.reasons;
    throw err;
  }
  return data;
}

export async function fetchVehicleListings(filters = {}) {
  const params = new URLSearchParams();
  if (filters.vehicleSourceId) params.set("vehicle_source_id", filters.vehicleSourceId);
  if (filters.listingStatus) params.set("listing_status", filters.listingStatus);
  if (filters.city) params.set("city", filters.city);
  if (filters.department) params.set("department", filters.department);
  if (filters.make) params.set("make", filters.make);
  if (filters.model) params.set("model", filters.model);
  if (filters.year) params.set("year", String(filters.year));
  if (filters.priceMin != null) params.set("price_min", String(filters.priceMin));
  if (filters.priceMax != null) params.set("price_max", String(filters.priceMax));
  if (filters.mileageMin != null) params.set("mileage_min", String(filters.mileageMin));
  if (filters.mileageMax != null) params.set("mileage_max", String(filters.mileageMax));
  if (filters.search) params.set("search", filters.search);
  if (filters.sellerType) params.set("seller_type", filters.sellerType);
  if (filters.sellerName) params.set("seller_name", filters.sellerName);
  if (filters.sourceType) params.set("source_type", filters.sourceType);
  if (filters.hasPriceDrop) params.set("has_price_drop", "true");
  if (filters.lastPriceChangeFrom) params.set("last_price_change_from", filters.lastPriceChangeFrom);
  if (filters.lastPriceChangeTo) params.set("last_price_change_to", filters.lastPriceChangeTo);
  if (filters.minPriceDeltaPct != null) {
    params.set("min_price_delta_pct", String(filters.minPriceDeltaPct));
  }
  if (filters.currentPriceMin != null) {
    params.set("current_price_min", String(filters.currentPriceMin));
  }
  if (filters.currentPriceMax != null) {
    params.set("current_price_max", String(filters.currentPriceMax));
  }
  if (filters.lowestPriceMin != null) {
    params.set("lowest_price_min", String(filters.lowestPriceMin));
  }
  if (filters.minObservationCount != null) {
    params.set("min_observation_count", String(filters.minObservationCount));
  }
  if (filters.minMissedRunCount != null) {
    params.set("min_missed_run_count", String(filters.minMissedRunCount));
  }
  if (filters.minDaysOnMarket != null) {
    params.set("min_days_on_market", String(filters.minDaysOnMarket));
  }
  if (filters.removedFrom) params.set("removed_from", filters.removedFrom);
  if (filters.removedTo) params.set("removed_to", filters.removedTo);
  if (filters.likelySoldFrom) params.set("likely_sold_from", filters.likelySoldFrom);
  if (filters.likelySoldTo) params.set("likely_sold_to", filters.likelySoldTo);
  if (filters.sort) params.set("sort", filters.sort);
  if (filters.sortDir) params.set("sort_dir", filters.sortDir);
  if (filters.limit) params.set("limit", String(filters.limit));
  const query = params.toString();
  const data = await requestJson(
    `/api/admin/mobility/vehicle-listings${query ? `?${query}` : ""}`
  );
  return data.listings || [];
}

export async function fetchVehicleListingById(id) {
  const data = await requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(id)}`
  );
  return data;
}

export async function runVehicleSourceDetailFetch(sourceId, payload = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-sources/${encodeURIComponent(sourceId)}/run-detail-fetch`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
}
